var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BreaksDuringWorkIndicator } from '@web/components/PerformanceReview/Employee/Sections/WorkLifeBalance/BreaksDuringWorkIndicator';
import { DaysWithExtendedWorkHours } from '@web/components/PerformanceReview/Employee/Sections/WorkLifeBalance/DaysWithExtendedWorkHours';
export var WorkLifeBalanceSection = function (_a) {
    var userId = _a.userId, orgUnitId = _a.orgUnitId;
    return (_jsxs("div", __assign({ className: "flex flex-col gap-20 mt-5" }, { children: [_jsx(DaysWithExtendedWorkHours, { userId: userId, orgUnitId: orgUnitId }), _jsx(BreaksDuringWorkIndicator, { userId: userId, orgUnitId: orgUnitId })] })));
};
